import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import User from "../../models/User";
import Tenant from "../../models/Tenant";
import { logout } from "../../actions/logout";
import { UserAvatar } from "../shared/UserAvatar";
import "./AccountDropdown.css";
import { NavigationUtils } from "../../util/NavigationUtils";
import {
  becomeUserDelegate,
  fetchUserDelegate,
} from "../../actions/userDelegate";
import { handleErrorWithDialog } from "../../util/Errors";
import Logger from "../../util/Logger";
import { ROUTE_ORG_DASH_ANALYTICS } from "../../Routes";
import store from "../../store/configureStore";
import { authApi } from "../../api/AuthApi";
import Tooltip from "../shared/Tooltip";
import _ from "lodash";
import PayMeModal from "../../money/PayMeModal";
import { GLOBAL_PATH_PREFIX } from "../../constants";
import { BrowserChecker } from "src/BrowserChecker";

class AccountDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPayMeMoney: false,
      showVerify: true,
    };
  }

  logoutUser = ($event) => {
    $event.preventDefault();
    $event.stopPropagation();

    Logger.info("LOGGING OUT");

    // Make sure the actual call succeeds, just incase store clear does not kick us out
    authApi
      .logout()
      .then(() => {
        Logger.info("Logout complete, back to POPin");
        NavigationUtils.backToPopin(true);
        store.dispatch(logout());
      })
      .catch((err) => {
        Logger.error(err);
        Logger.warn("Logout error, back to POPin anyway");
        NavigationUtils.backToPopin(true);
        store.dispatch(logout());
      });
  };

  componentDidMount() {
    this.fetchDelegates();
  }

  fetchDelegates = () => {
    const { user, fetchUserDelegate } = this.props;
    if (!!user && !User.isGuest(user)) {
      fetchUserDelegate();
    }
  };

  handleManageDelegates = ($event) => {
    $event.preventDefault();

    NavigationUtils.routeToLegacy("/manage-users");
  };

  handleBecomeDelegate = (delegateId) => {
    const { becomeUserDelegate } = this.props;
    becomeUserDelegate(delegateId);
  };

  handleSessionBecameDelegate = (newUser, oldUser) => {
    Logger.info("Session became delegate");
    if (newUser && oldUser) {
      const delegate = User.getDelegate(newUser);
      const oldDelegate = User.getDelegate(oldUser);

      // If the delegates have changed
      if (
        (!oldDelegate && delegate) || // delegate set
        (oldDelegate && !delegate) || // delegate unset
        (oldDelegate && delegate && oldDelegate.id !== delegate.id) || // delegate changed
        oldUser.id !== newUser.id // delegate changed
      ) {
        Logger.info("Delegates have changed");
        // Reload the dashboard page
        if (!NavigationUtils.backToPopin()) {
          window.location.reload();
        }
      }
    }
  };

  componentDidUpdate(prevProps) {
    const { user, becomeError } = this.props;

    handleErrorWithDialog(
      becomeError,
      prevProps.becomeError,
      "Unable to Access Other Account"
    );

    this.handleSessionBecameDelegate(user, prevProps.user);
  }

  handleUpgrade = () => {
    this.setState({ showPayMeMoney: true });
  };

  onHideModal = () => {
    this.setState({ showPayMeMoney: false });
  };

  render() {
    const { isEnterprise, user, delegates, loggingOut } = this.props;
    const { showPayMeMoney } = this.state;

    let allowed =
      user &&
      (user.is_tenant_account_owner ||
        user.role_type === "org_admin" ||
        user.role_type === "org_owner");

    allowed = !!_.get(user, "tenant.org_dashboard_enabled");

    const isMobile = BrowserChecker.isMobile();

    return (
      <div className="m-auto fix-ie nav-item h-100 account-dropdown">
        <div className="d-inline-block col dropdown h-100 fix-ie">
          <div
            id="nav-dropdown"
            className="row no-gutters d-flex h-100 fix-ie"
            data-toggle={`${user && !loggingOut ? "dropdown" : ""}`}
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div
              className={`fix-ie h-100 m-auto list-item ${
                user && !loggingOut ? "clickable" : ""
              }`}
            >
              <Tooltip tooltip="Account">
                <UserAvatar user={user} simple={true} border={true} />
              </Tooltip>
            </div>
          </div>

          {user && (
            <div
              className="dropdown-menu mt-3 be-free"
              aria-labelledby="nav-dropdown"
            >
              <div className="col" />
              <div className="the-real-dropdown">
                <AvatarSettingsSection user={user} />

                {delegates && delegates.length > 0 && (
                  <div className="dropdown-divider" />
                )}

                <UserDelegateSection
                  user={user}
                  delegateList={delegates}
                  onBecome={this.handleBecomeDelegate}
                />

                {!User.isGuest(user) && <div className="dropdown-divider" />}

                {!!user.plan.upgradeable && (
                  <a
                    className="dropdown-menu-item col clickable py-2"
                    target="#subscription"
                    href="https://www.trypopin.com/popin-subscription-options">
                    <strong>Start My POPin Subscription</strong>
                  </a>
                )}

                {!User.isDelegatingAs(user) && !User.isGuest(user) && (
                  <div
                    className="dropdown-menu-item col clickable py-2"
                    onClick={this.handleManageDelegates}
                  >
                    Manage My Account Access
                  </div>
                )}

                {!isEnterprise &&
                  allowed &&
                  !User.isDelegatingAs(user) &&
                  !User.isGuest(user) &&
                  !isMobile && (
                    <Link
                      className="col clickable py-2 nocolor-a"
                      to={`${GLOBAL_PATH_PREFIX}/${ROUTE_ORG_DASH_ANALYTICS}`}
                    >
                      Enterprise Dashboard
                    </Link>
                  )}

                {!User.isDelegatingAs(user) && (
                  <div className="dropdown-divider" />
                )}

                <div className="text-center">
                  <button onClick={this.logoutUser} className="btn btn-primary">
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {!!showPayMeMoney && (
          <PayMeModal
            user={user}
            openedFrom="React: Upgrade from Account Dropdown"
            onHidden={this.onHideModal}
          />
        )}

        {!!user && !user.verified && !user.guest && this.state.showVerify && (
          <div className="row no-gutters verify-account">
            <div
              className="verify-content clickable"
              onClick={() => NavigationUtils.routeToLegacy("/settings")}
            >
              <span>Click here to verify your email address</span>
              <i
                className="material-icons clickable"
                onClick={($e) => {
                  $e.preventDefault();
                  $e.stopPropagation();
                  this.setState({ showVerify: false });
                }}
              >
                close
              </i>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const UserDelegateSection = ({ user, delegateList, onBecome }) => {
  const Avatar = ({ delegate }) => {
    const avatar = delegate ? User.getMediaAvatarPhoto(delegate) : null;
    const initials = delegate ? User.getInitials(delegate) || "" : "";
    return (
      <div className="avatar m-auto">
        {avatar ? (
          <img src={avatar} alt="User Avatar" className="fit-avatar" />
        ) : (
          <div className="initials d-flex h-100 w-100 align-items-center">
            <span className="m-auto">{initials}</span>
          </div>
        )}
      </div>
    );
  };

  const Name = ({ delegate }) => {
    const name = delegate
      ? User.getDisplayName(delegate) || "Not available"
      : "Not available";
    return (
      <div className="text-truncate pr-2">
        <span className="align-middle name text-truncate">{name}</span>
      </div>
    );
  };

  const Email = ({ delegate }) => {
    const email = delegate
      ? User.getEmail(delegate) || "Not available"
      : "Not available";
    return (
      <div className="text-truncate pr-2">
        <span className="align-middle email text-truncate">{email}</span>
      </div>
    );
  };

  const handleDelegateClicked = ($event, user, delegate) => {
    $event.preventDefault();

    const delegateId = User.getId(delegate);
    const currentUserId = User.getId(user);
    if (delegateId && currentUserId !== delegateId) {
      onBecome(delegateId);
    }
  };

  // Make a new list so we don't bust up the source list when we act on it.
  const delegates = [];
  for (let delegate of delegateList) {
    delegates.push(delegate);
  }

  if (!delegates || delegates.length === 0) {
    return null;
  } else {
    // If we are browsing as a delegate, add ourselves to the list
    const userDelegate = User.getDelegate(user);
    if (!!userDelegate) {
      delegates.unshift(userDelegate);
    }

    const id = userDelegate ? User.getId(userDelegate) : null;
    return (
      <div className="col delegate-section">
        <div className="delegate-header mb-2 px-3">
          Other Accounts You Can Access
        </div>
        <div className="delegate-list">
          {delegates
            .filter((delegate) => {
              if (!userDelegate) {
                // If we are not delegating, show everyone
                return true;
              } else {
                // If we are delegating, hide the currently selected user
                return User.getId(delegate) !== User.getId(user);
              }
            })
            .map((delegate) => {
              const delegateId = User.getId(delegate);
              return (
                <div
                  key={delegateId}
                  className="row no-gutters px-3 my-2 clickable"
                  onClick={($event) =>
                    handleDelegateClicked($event, user, delegate)
                  }
                >
                  <Avatar delegate={delegate} />

                  <div className="col ml-3 text-truncate">
                    <Name delegate={delegate} />
                    <Email delegate={delegate} />
                    {id === delegateId && (
                      <div className="default-delegate">(default)</div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
};

const AvatarSettingsSection = ({ user }) => {
  const routeToAccountSettings = ($event) => {
    $event.preventDefault();

    NavigationUtils.routeToLegacy("/settings");
  };

  const Avatar = ({ user }) => {
    const avatar = user ? User.getMediaAvatarPhoto(user) : null;
    const initials = user ? User.getInitials(user) || "" : "";
    return (
      <div className="avatar m-auto">
        {avatar ? (
          <img src={avatar} alt="User Avatar" className="fit-avatar" />
        ) : (
          <div className="initials d-flex h-100 w-100 align-items-center">
            <span className="m-auto">{initials}</span>
          </div>
        )}
      </div>
    );
  };

  const MyAccountButton = ({ onClick }) => {
    return (
      <div className="my-2">
        <button onClick={onClick} className="btn btn-secondary">
          My Account
        </button>
      </div>
    );
  };

  const Name = ({ user }) => {
    const name = user
      ? User.isGuest(user)
        ? "Guest"
        : User.getDisplayName(user) || "Not available"
      : "Not available";
    return (
      <div className="text-truncate pr-2">
        <span className="align-middle name">{name}</span>
      </div>
    );
  };

  const Email = ({ user }) => {
    const email = user
      ? User.isGuest(user)
        ? ""
        : User.getEmail(user) || "Not available"
      : "Not available";
    return (
      <div className="text-truncate pr-2">
        <span className="align-middle email">{email}</span>
      </div>
    );
  };

  return (
    <div
      onClick={routeToAccountSettings}
      className="col avatar-section clickable"
    >
      <div className="row no-gutters">
        <div className="col-4 m-auto">
          <Avatar user={user} />
        </div>

        <div className="col-8">
          <Name user={user} />
          <Email user={user} />
          <MyAccountButton onClick={routeToAccountSettings} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  return {
    user: user,
    delegates: state.userDelegate.delegates || [],
    orgName:
      user && User.hasTenant(user) ? Tenant.getName(User.getTenant(user)) : "",
    loggingOut: state.logout.loggingOut,
    becomingDelegate: state.userDelegate.becoming,
    becomeError: state.userDelegate.becomeError,
  };
};

export default connect(mapStateToProps, {
  logout,
  fetchUserDelegate,
  becomeUserDelegate,
})(AccountDropdown);
